import { useState } from 'react';

export const useHighlightSugestion = () => {
  const [highlightSugestion, setHighlightSugestion] = useState<boolean>(false);

  const handleHoverSugestionButton = (eventType: string) =>
    eventType === 'mouseenter' ? setHighlightSugestion(true) : setHighlightSugestion(false);

  return {
    highlightSugestion,
    handleHoverSugestionButton,
  };
};
